import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;

  text-align: left;
  margin-top: 0;

  min-height: 22px;
`;
